import React from 'react'
import { Select, SelectItem } from "@nextui-org/react";

export const SelectDefaultVariants = {
  flat: 'flat',
  bordered: 'bordered',
  underlined: 'underlined',
  faded: 'faded',
}

export const SelectDefaultLabelPlacements = {
  inside: 'inside',
  outside: 'outside',
  outsideLeft: 'outside-left',
};

export default function SelectDefault(props) {
  const {
    name,
    list,
    label,
    placeholder = null,
    selectionMode = "single",
    isRequired = false,
    variant = SelectDefaultVariants.flat,
    description = null,
    className = "max-w-xs", 
    onChange=() => {},
    defaultSelectedKey = null,
  } = props
  return (
    <div className="flex w-full flex-wrap md:flex-nowrap gap-4">
      <Select
        name={name}
        label={label}
        isRequired={isRequired}
        placeholder={placeholder}
        selectionMode={selectionMode}
        variant={variant}
        labelPlacement={SelectDefaultLabelPlacements.inside}
        description={description}
        onChange={onChange}
        className={className}
        defaultSelectedKeys={defaultSelectedKey || [list[0]?.value]}
      >
        {list.map((item) => (
          <SelectItem 
            aria-label={item.name} 
            key={item.value} 
            value={item.value}
          >
            {item.name}
          </SelectItem>
        ))}
      </Select>
    </div>
  )
}
